import React from 'react';
import { Box, Flex, FormLabel, Wrap, WrapItem } from '@chakra-ui/react';

/** Matches mobile SegmentedPills — amber selected, bordered chips. */
export function SegmentedPills({
  label,
  options = [],
  value,
  onChange,
  multi = false,
  values = [],
}) {
  const isSelected = (option) =>
    multi ? values.includes(option) : option === value;

  const handleSelect = (option) => {
    if (!onChange) return;
    if (multi) {
      if (values.includes(option)) {
        onChange(values.filter((v) => v !== option));
      } else {
        onChange([...values, option]);
      }
      return;
    }
    onChange(option);
  };

  return (
    <Box>
      {label ? <FormLabel mb={2}>{label}</FormLabel> : null}
      <Wrap spacing={2}>
        {options.map((option) => {
          const selected = isSelected(option);
          return (
            <WrapItem key={option}>
              <Flex
                as="button"
                type="button"
                onClick={() => handleSelect(option)}
                px={4}
                py={2.5}
                borderRadius="sm"
                borderWidth="1px"
                borderColor={selected ? 'utkarsh.amber' : 'border.subtle'}
                bg={selected ? 'utkarsh.amber' : 'bg.surface'}
                color="text.primary"
                fontSize="14px"
                fontWeight={selected ? '600' : '500'}
                cursor="pointer"
                transition="all 0.15s"
                _hover={{ borderColor: selected ? 'utkarsh.amber' : 'text.secondary' }}
              >
                {option}
              </Flex>
            </WrapItem>
          );
        })}
      </Wrap>
    </Box>
  );
}
